(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name itecAdministracio.api.entitat.factory:EntitatFactory
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.api.entitat')
    .factory('EntitatFactory', EntitatFactory);

  function EntitatFactory(AdmConstant, DataFactory) {
    var api = AdmConstant.SERVER_PATH_ADMINISTRACIO + 'entitats';

    var EntitatBase = {

      getAll: function(form){
        var url = api;
        return DataFactory.getWithParams(url, form);
      },

      get: function(id){
        var url = api + '/' + id;
        return DataFactory.get(url);
      },

      add: function(obj){
        return DataFactory.add(api,obj);
      },

      update: function(id, obj){
        var url = api + '/' + id;
        return DataFactory.update(url,obj);
      },
      delete: function(id){
        var url = api;
        return DataFactory.delete(url, id);
      },
      getsessions: function(id){
        var url = api + '/' + id + '/sessions';
        return DataFactory.get(url);
      },
      update_all_users: function(id, obj){
        var url = api + '/notificacio' + '/' + id;
        return DataFactory.update(url,obj);
      },
      getGroup: function(id){
        var url = api + '/' + id + '/group';
        return DataFactory.get(url);
      }
    };
    return EntitatBase;
  }
}());
